/* eslint-disable no-console */
import React from 'react';
import Footer from '../../components/Footer_fr';
import DocumentMeta from 'react-document-meta';
import headshot from '../../media/photo3.jpg';
import './styles.scss';
import Menu from '../../components/Menu_fr';
import News from '../../components/News_fr';

function Home() {
  const mainStyle = 'francais';

  const title = 'Anthony Coache';

  return (
    <div>
      <DocumentMeta title={title} />
      <Menu menu={Menu} />
      <div className={mainStyle}>
        {/* <h2 className={`${mainStyle}__heading`}>Homepage</h2> */}
        <div className={`${mainStyle}__headshot`}>
          <img className={`${mainStyle}__img`} src={headshot} alt="Anthony Coache" />
        </div>
        <h2>À propos de moi</h2>
        <div className="bio">
          {/*<p>
            Je suis présentement .......
          </p>*/}
          <p>
            {/*Auparavant, j'étais associé de recherche au sein du groupe de mathématiques financières du département de mathématiques à
            <a href="https://www.imperial.ac.uk/mathematical-finance/" target="_blank" rel="noreferrer"> Imperial College London</a>, sous la direction de <a href="</a>https://www.ma.imperial.ac.uk/~jmuhleka/" target="_blank" rel="noreferrer"> Prof. Johannes Muhle-Karbe</a>. Mes travaux portaient principalement sur la gestion quantitative des risques, l'optimisation et la microstructure des marchés, avec des applications au domaine du trading et de la prise de décision en situation d'incertitude. J'ai également supervisé des projets de recherche de maîtrise menés avec des banques et hedge funds de premier plan, incluant Morgan Stanley, Qube-RT et Deutsche Bank.*/} En tant qu'associé de recherche au sein du groupe de mathématiques financières du département de mathématiques à
            <a href="https://www.imperial.ac.uk/mathematical-finance/" target="_blank" rel="noreferrer"> Imperial College London</a>, sous la direction de <a href="</a>https://www.ma.imperial.ac.uk/~jmuhleka/" target="_blank" rel="noreferrer"> Prof. Johannes Muhle-Karbe</a>, mes travaux portaient principalement sur la gestion quantitative des risques, l'optimisation et la microstructure des marchés, avec des applications au domaine du trading et de la prise de décision en situation d'incertitude. J'ai également supervisé des projets de recherche de maîtrise menés avec des banques et hedge funds de premier plan, incluant Morgan Stanley, Qube-RT et Deutsche Bank.
          </p>
          <p>
            J'ai reçu un doctorat en statistique à <a href="https://www.statistics.utoronto.ca/" target="_blank" rel="noreferrer">l'Université de Toronto </a>
            sous la supervision de <a href="http://sebastian.statistics.utoronto.ca/" target="_blank" rel="noreferrer"> Prof. Sebastian Jaimungal</a>, et
            obtenu un M.Sc. et B.Sc. avec mention d'honneur en mathématiques et statistique de <a href="https://sciences.uqam.ca/statistique/" target="_blank" rel="noreferrer">l'Université du Québec à Montréal</a>.
            Au cours de mon doctorat, j'ai développé des algorithmes de prise de décision pour résoudre des problèmes de contrôle séquentiel avec des mesures de risque dynamiques cohérentes dans le temps.
            Mes travaux ont été récompensés notamment par le prix d'excellence pour la recherche doctorale du DoSS de l'Université de Toronto, le
            <a href="https://www.siam.org/prizes-recognition/activity-group-prizes/detail/siag-fme-conference-paper-prize" target="_blank" rel="noreferrer"> SIAG/FME Conference Paper Prize</a>
            , et un financement <a href="https://www.nserc-crsng.gc.ca/index_eng.asp" target="_blank" rel="noreferrer">CRSNG </a>
            du premier cycle jusqu'au post-doctorat.
          </p>
        </div>
        <hr />
        <h2>Actualités</h2>
        <News news={News} />
      </div>
      <Footer/>
    </div>
  );
}

export default Home;
